import { fetcher } from '@commenda/utils';

import {
  TIndirectTaxBulkActionTransactionsParams,
  TIndirectTaxBulkDeleteTransactionsByFiltersResponse,
  TIndirectTaxBulkDeleteTransactionsByIdsResponse,
} from './types';

export async function bulkDeleteIndirectTaxTransactions(
  body: TIndirectTaxBulkActionTransactionsParams
): Promise<{
  success: boolean;
  error?: string;
  data?:
    | TIndirectTaxBulkDeleteTransactionsByIdsResponse
    | TIndirectTaxBulkDeleteTransactionsByFiltersResponse;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/transactions/bulk/delete',
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to delete transactions',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to delete transactions',
    };
  }
}
